// @ts-strict-ignore
import { MyEditor } from 'src/components/textEditor/customHelpers';

export const withImages = editor => {
  const { insertData, isVoid } = editor;

  editor.isVoid = element => {
    return element.type === 'image' ? true : isVoid(element);
  };

  // will work for copy-pasting images, too
  editor.insertData = data => {
    const { files } = data;

    if (files && files.length > 0) {
      for (const file of files) {
        const reader = new FileReader();
        const [mime] = file.type.split('/');

        if (mime === 'image') {
          reader.addEventListener('load', () => {
            const url = reader.result;
            MyEditor.insertImage({ editor, url, file });
          });

          reader.readAsDataURL(file);
        }
      }
      // for future work - insert img from img url pasted in txt
    // } else if (isImageUrl(text)) {
    //   insertImage(text);
    } else {
      insertData(data);
    }
  };

  return editor;
};
